import axios from '../../plugins/axios.js';

export default{
  async getCampaigns() {
    return await axios.get('api/Campaign');
  },
  async getCampaignsByID(campaignId) {
    return await axios.get(`/api/Campaign/${campaignId}`);
  }, 
  async createCampaign(campaign) {
    return await axios.post('/api/Campaign', campaign);
  },
  async updateCampaign(campaign) {
    return await axios.put('/api/Campaign', campaign);
  },  
  async getCampaignStatuses() {
    return await axios.get('api/campaign/CampaignStatus');
  },
  async archiveCampaign(campaignValues) {
    return await axios.post('/api/campaign/archiveCampaign', campaignValues);
  },
  async getCampaignSourceTypes() {
    return await axios.get('/api/CampaignSourceType');
  },
  async getLocalPhoneNumbers(areaCode,region,noOfDid) {
    return await axios.get(`/api/PhoneNumberRepository/LocalPhoneNumbers?areacode=${areaCode}&region=${region}&numberOfPhoneNumbers=${noOfDid}`);
  },
  async getTollFreePhoneNumbers(noOfDid) {
    return await axios.get(`/api/PhoneNumberRepository/TollFreePhoneNumbers?numberOfPhoneNumbers=${noOfDid}`);
  },
  async getCampaignCallPaths(campaignId) {
    return await axios.get(`/api/campaigncallpath/${campaignId}`);
  },  
  async createCampaignCallPath(callPath) {
    return await axios.post('/api/campaigncallpath', callPath);
  },
  async updateCampaignCallPath(callPath) {
    return await axios.put('/api/campaigncallpath', callPath);
  },
  async getCampaignsByCallPathID(callPathID) {  
    return await axios.get(`/api/CampaignCallPath/GetCampaignsByCallPathId/${callPathID}`);
  },
  async getCampaignCallTypes() {
    return await axios.get('/api/CampaignCallType');
  },
  async getAffiliateTypes() {
    return await axios.get('/api/AffiliateTypes');
  },
  async getCampaignApiKey(campaignId, displayFormat){
    return await axios.get(`api/campaign/GetCampaignApiKey?campaignId=${campaignId}&displayFormat=${displayFormat}`);
  },
  async getCampaignEntities() {
    return await axios.get('api/Campaign/GetCampaignEntities');
  },
  async getCampaignNameAndDids() {
    return await axios.get('api/Campaign/GetCampaignNameAndDids');
  },
  async getChannelList(){
    return await axios.get('api/Campaign/GetChannelList');
  },
  async GetClientList(){
    return await axios.get('api/Campaign/GetClientList');
  },
  async getSuppressedQuestionMappings() {
    return await axios.get('/api/Campaign/GetSuppressedQuestionMappings');
  },
  async updateSuppressedQuestionMappings(suppressedQuestionMappingsData) {
    return await axios.put('/api/Campaign/UpdateSuppressedQuestionMappings', suppressedQuestionMappingsData);
  },
  async GetCampaignDropdowns(){
    return await axios.get('api/campaign/GetCampaignDropdowns');
  },
  async GetCamapignCallAttributes(campaignId){
    return await axios.get(`api/campaign/GetCamapignCallAttributes/${campaignId}`);
  },
  async UpdateCamapignCallAttributes(callAttribute) {
    return await axios.post('/api/campaign/UpdateCamapignCallAttributes', callAttribute);
  },
};
